function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_iii_18590_568)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6023 2.05005C7.91234 2.05005 1.65234 8.31005 1.65234 16C1.65234 23.69 7.91234 29.95 15.6023 29.95C23.2923 29.95 29.5523 23.7 29.5523 16C29.5523 8.30005 23.3023 2.05005 15.6023 2.05005ZM26.5423 16C26.5423 18.3675 25.7798 20.5604 24.4926 22.3498C24.4041 22.4727 24.2269 22.4847 24.1198 22.3776L9.22505 7.49262C9.11785 7.38549 9.12974 7.2082 9.25277 7.1197C11.0421 5.83251 13.235 5.07005 15.6023 5.07005C21.6323 5.06005 26.5423 9.97005 26.5423 16ZM4.66234 16C4.66234 13.6231 5.43402 11.4298 6.72202 9.64038C6.81054 9.5174 6.98777 9.50548 7.09492 9.61262L21.9892 24.5069C22.0966 24.6143 22.0844 24.7919 21.961 24.8803C20.1628 26.1683 17.9698 26.94 15.6023 26.94C9.57234 26.94 4.66234 22.03 4.66234 16Z",
  fill: "url(#paint0_linear_18590_568)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_18590_568)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.4926 22.3497C25.7799 20.5603 26.5424 18.3674 26.5424 16C26.5424 9.96996 21.6324 5.05996 15.6024 5.06996C13.235 5.06996 11.0422 5.83242 9.25278 7.11961C9.12975 7.20811 9.11786 7.38541 9.22506 7.49254L24.1198 22.3775C24.2269 22.4846 24.4041 22.4727 24.4926 22.3497Z",
  fill: "url(#paint1_linear_18590_568)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.72203 9.64029C5.43403 11.4297 4.66235 13.623 4.66235 16C4.66235 22.03 9.57235 26.94 15.6024 26.94C17.9698 26.94 20.1628 26.1682 21.961 24.8802C22.0844 24.7918 22.0966 24.6142 21.9892 24.5068L7.09493 9.61254C6.98778 9.50539 6.81055 9.51731 6.72203 9.64029Z",
  fill: "url(#paint2_linear_18590_568)"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_iii_18590_568",
  x: 1.35234,
  y: 1.65005,
  width: 28.6,
  height: 28.6,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.882353 0 0 0 0 0.113725 0 0 0 0 0.333333 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18590_568"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.827451 0 0 0 0 0.168627 0 0 0 0 0.172549 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18590_568",
  result: "effect2_innerShadow_18590_568"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.458824 0 0 0 0 0.568627 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_18590_568",
  result: "effect3_innerShadow_18590_568"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_18590_568",
  x: 4.36235,
  y: 5.06995,
  width: 22.18,
  height: 22.17,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.3,
  dy: 0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.901961 0 0 0 0 0.819608 0 0 0 0 0.901961 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18590_568"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18590_568",
  x1: 28.0273,
  y1: 16,
  x2: 10.5273,
  y2: 16,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5075"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4B51"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_18590_568",
  x1: 21.6523,
  y1: 7.79996,
  x2: 11.7148,
  y2: 18.4875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF7FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBF2FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_18590_568",
  x1: 21.6523,
  y1: 7.79996,
  x2: 11.7148,
  y2: 18.4875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF7FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBF2FF"
})));

function SvgProhibited(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibited);
export default __webpack_public_path__ + "static/media/prohibited.2dd38249.svg";
export { ForwardRef as ReactComponent };